import { render, staticRenderFns } from "./BespokeWebsitesPage.vue?vue&type=template&id=493bd692&"
import script from "./BespokeWebsitesPage.vue?vue&type=script&lang=js&"
export * from "./BespokeWebsitesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports